export default {
    classification_types: {
        titles: "Tipos Classificação",
        title: "Tipo Classificação",
        list: {
            name: "Nome",
            inspectable: "Inspecionável",
            status: "Ativo"
        },
        model: {
            name: "Nome",
            inspectable: "Inspecionável",
            status: "Ativo"
        },
        help: {
            inspectable: "Permite definir se os processos deste tipo são passíveis de serem fiscalizados."
        }
    },
    construction_types: {
        titles: "Tipos Construção",
        title: "Tipo Construção",
        list: {
            name: "@:construction_types.model.name",
            status: "@:construction_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    order_types: {
        titles: "Tipos Pedido",
        title: "Tipo Pedido",
        list: {
            name: "@:order_types.model.name",
            status: "@:order_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    procedure_types: {
        titles: "Tipos Procedimento",
        title: "Tipo Procedimento",
        list: {
            name: "@:procedure_types.model.name",
            status: "@:procedure_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    use_types: {
        titles: "Tipos Utilização",
        title: "Tipo Utilização",
        list: {
            name: "@:use_types.model.name",
            status: "@:use_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    regime_types: {
        titles: "Tipos Regime",
        title: "Tipo Regime",
        list: {
            name: "@:regime_types.model.name",
            status: "@:regime_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    limit_types: {
        titles: "Tipos Limite",
        title: "Tipo Limite",
        list: {
            name: "@:limit_types.model.name",
            code: "@:limit_types.model.code",
            importable: "@:limit_types.model.importable",
            confrontable: "@:limit_types.model.confrontable",
            status: "@:limit_types.model.status"
        },
        model: {
            name: "Nome",
            code: "Código",
            importable: "Importável",
            confrontable: "Confrontável",
            status: "Ativo"
        },
        settings: {
            draw: {
                title: "Informação para Desenho",
                status: "Ativo",
                help: {
                    status: "Permite ativar/desativar o desenho"
                }
            },
            upload: {
                title: "Informação para Upload",
                status: "Ativo",
                filterProperty: "Nome(s) do campo/propriedade",
                help: {
                    status: "Permite ativar/desativar o upload",
                    filterProperty: "Multiplos valores separados por <b>virgula</b>. Nome da propriedade para filtrar os elementos."
                }
            }
        }
    },
    statuses: {
        titles: "Tipos Situação",
        title: "Tipo Situação",
        list: {
            name: "@:statuses.model.name",
            status: "@:statuses.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    states: {
        titles: "Tipos Estado",
        title: "Tipo Estado",
        list: {
            name: "@:states.model.name",
            status: "@:states.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    source_types: {
        titles: "Tipos Fonte",
        title: "Tipo Fonte",
        list: {
            name: "@:source_types.model.name",
            status: "@:source_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    document_types: {
        titles: "Tipos Documento",
        title: "Tipo Documento",
        list: {
            name: "@:document_types.model.name",
            status: "@:document_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    },
    entities: {
        titles: "Entidades",
        title: "Entidade",
        list: {
            id: "@:entities.model.id",
            name: "@:entities.model.name",
            status: "@:entities.model.status"
        },
        model: {
            id: "Código",
            name: "Nome",
            email: "E-mail",
            phone: "Contato",
            nif: "NIF",
            address: "Morada",
            dicofre: "Freguesia",
            cp7: "Código Postal (CP7)",
            category: "Categoria",
            status: "Ativo"
        }
    },
    confrontations: {
        titles: "Confrontações",
        title: "Confrontação",
        list: {
            order: "Ordem",
            name: "Nome",
            status: "Ativo"
        }
    },
    matrix_classification_types: {
        titles: "Tipos Classificações Matricial",
        title: "Tipo Classificação Matricial",
        list: {
            name: "@:matrix_classification_types.model.name",
            status: "@:matrix_classification_types.model.status",
            code: "@:matrix_classification_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    license_types: {
        titles: "Tipos Licença",
        title: "Tipo Licença",
        list: {
            name: "@:license_types.model.name",
            status: "@:license_types.model.status"
        },
        model: {
            name: "Nome",
            status: "Ativo"
        }
    }
};
